import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const Product = ({ size = 24, ...props }: { size: number }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="#F2F7FF"
        d="M21.7 0H2.5A2.4 2.4 0 0 0 .1 2.4v19.2A2.4 2.4 0 0 0 2.5 24h19.2a2.4 2.4 0 0 0 2.4-2.4V2.4A2.4 2.4 0 0 0 21.7 0Z"
      />
      <Path
        fill="#3D66A9"
        d="M19.382 15.539 7.56 17.642a1.344 1.344 0 0 1-1.555-1.099L4.702 9.095a1.354 1.354 0 0 1 1.09-1.57L17.615 5.42c.73-.13 1.427.362 1.555 1.1l1.302 7.448a1.354 1.354 0 0 1-1.09 1.57Z"
      />
      <Path
        fill="url(#b)"
        d="M16.995 19.065H5.243A1.35 1.35 0 0 1 3.9 17.71v-7.378a1.35 1.35 0 0 1 1.343-1.355h11.752a1.35 1.35 0 0 1 1.343 1.355v7.378a1.35 1.35 0 0 1-1.343 1.355Z"
      />
      <Path fill="url(#c)" d="M3.9 11.283h14.438v2.305H3.9v-2.305Z" />
      <Path
        fill="url(#d)"
        d="M7.899 16.827H5.614a.506.506 0 0 0-.504.508c0 .281.226.509.504.509h2.285a.506.506 0 0 0 .503-.509.506.506 0 0 0-.503-.508Z"
      />
    </G>
    <Defs>
      <RadialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-12.19085 9.13586 -8.15428 -10.88104 17.24 9.634)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-11.6395 0 0 -17.7518 13.57 12.431)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#CD9A58" />
      </RadialGradient>
      <RadialGradient
        id="d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-2.65409 0 0 -7.82591 7.315 17.334)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#CD9A58" />
      </RadialGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default Product
